<template>
    <TimeExpense></TimeExpense>
</template>

<script>
import { defineAsyncComponent } from "vue";

const TimeExpense = defineAsyncComponent(() =>
    import("../../components/Hr/TimeExpense/TimeExpense.vue")
);
export default {
    name: "Roles",
    components: { TimeExpense },
};
</script>

<style scoped></style>